<template>
  <el-dialog
    v-model="dialogVisible"
    class="settings-modal" align-center @open="onDialogOpen"
    @closed="closedModal">
    <template #header>
      <el-breadcrumb :separator-icon="ArrowRight">
        <el-breadcrumb-item>{{ city }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-form
      @submit.prevent="form.id ? updateFilial() : createFilial()"
      ref="form"
      :model="form"
      status-icon
      label-position="right"
      label-width="auto"
      :rules="rules"
    >
      <el-form-item prop="name" label="Название">
        <el-input
          ref="branchInput"
          @input="changeForm"
          placeholder="Название"
          v-model="form.name"
          type="text"
          autocomplete="off"
        />
      </el-form-item>
      <el-form-item>
        <template #label>
          <span style="color: var(--el-color-danger); margin-right: 4px;">*</span> Рабочее время
        </template>
        <el-form-item prop="working.start">
          <el-time-select
            v-model="form.working.start"
            style="width: 160px; margin-right: 10px"
            class="mr-4"
            @change="changeForm"
            placeholder="Start time"
            start="08:00"
            step="00:15"
            end="23:00"
          />
        </el-form-item>
        <el-form-item prop="working.end">
          <el-time-select
            v-model="form.working.end"
            style="width: 160px"
            @change="changeForm"
            placeholder="End time"
            start="08:00"
            step="00:15"
            end="23:00"
          />
        </el-form-item>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">Отмена</el-button>
        <el-button v-if="!form.id" type="primary" :loading="loading" @click="createFilial">
          Добавить
        </el-button>
        <el-button v-else type="primary" :disabled="disableButton" :loading="loading" @click="updateFilial">
          Обновить
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { ArrowRight } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import store from '@/components/store/store'

export default {
  name: 'ModalBranch',
  computed: {
    ArrowRight() {
      return ArrowRight
    }
  },
  data() {
    return {
      city: 'Филиал',
      title: 'Филиал',
      dialogVisible: false,
      disableButton: true,
      loading: false,
      form: {},
      rules: {
        name: [{ required: true, message: 'Обязательно для заполнения', trigger: 'blur' }],
        'working.start': [{ required: true, message: 'Обязательно для заполнения', trigger: 'change' }],
        'working.end': [{ required: true, message: 'Обязательно для заполнения', trigger: 'change' }]
      }
    }
  },
  methods: {
    onDialogOpen() {
      this.$nextTick(() => {
        this.$refs.branchInput.focus()
      })
    },
    closedModal() {
      this.form = {
        id: null,
        name: '',
        working: {
          start: null,
          end: null
        }
      }
    },
    open(item, city_name) {
      this.form = JSON.parse(JSON.stringify(item))
      this.dialogVisible = true
      this.city = city_name
      if (this.form.id === null) {
        this.title = 'новый филиал'
      } else {
        this.title = this.form.name
      }

      console.log(this.form)
    },
    changeForm() {
      this.disableButton = this.form.working.start === '' || this.form.working.end === '' || this.form.working.start === null || this.form.working.end === null
        || this.form.name === ''
    },
    async createFilial() {
      this.loading = true
      try {
        await this.$refs.form.validate()
      } catch (e) {
        ElMessage.error('Заполните необходимые поля')
        this.loading = false
        return
      }
      await store.dispatch('cities/addBranch', {
        city_id: this.form.city_id,
        name: this.form.name,
        time: this.form.working
      })
      this.loading = false
      this.dialogVisible = false
      this.$emit('update-city', this.form.city_id)
    },
    async updateFilial() {
      this.loading = true
      try {
        await this.$refs.form.validate()
      } catch (e) {
        ElMessage.error('Заполните необходимые поля')
        this.loading = false
        return
      }
      await store.dispatch('cities/updateBranch', { id: this.form.id, name: this.form.name, time: this.form.working })
      this.loading = false
      this.dialogVisible = false
      this.$emit('update-city', this.form.city_id)
    }
  }
}
</script>
<style>
</style>
